import { gql } from 'apollo-boost';

export const signInQuery = gql`
  mutation SignIn($username: String!, $password: String!) {
    SignIn(input: { username: $username, password: $password }) {
      token
      expire
    }
  }
`;

export const signInPageQuery = gql`
  mutation SignIn($pageId: ID!) {
    SignInPage(input: { pageId: $pageId }) {
      token
      expire
    }
  }
`;

export const signUpQuery = gql`
  mutation SignUp($username: String!, $password: String!) {
    SignUp(input: { username: $username, password: $password }) {
      token
      expire
    }
  }
`;

export const signUpWithPhoneNumberQuery = gql`
  mutation SignUpWithPhoneNumber($phoneNumber: String!) {
    SignUpWithPhoneNumber(input: { phoneNumber: $phoneNumber })
  }
`;

export const verifyWithPhoneNumberQuery = gql`
  mutation VerifyWithPhoneNumber($phoneNumber: String!, $code: String!) {
    VerifyWithPhoneNumber(input: { phoneNumber: $phoneNumber, code: $code }) {
      token
      expire
    }
  }
`;

export const continueWithGoogleQuery = gql`
  mutation ContinueWithGoogle($googleToken: String!) {
    ContinueWithGoogle(input: { googleToken: $googleToken }) {
      token
      expire
    }
  }
`;

export const changePasswordQuery = gql`
  mutation SignIn($newPassword: String!) {
    ChangePassword(input: { newPassword: $newPassword })
  }
`;

export const getUserProfileQuery = gql`
  query {
    UserProfile {
      fullname
      username
      avatar {
        id
        url
        thumbnailUrl
      }
      isPageSelected
      currentPage {
        id
        fullname
        avatar {
          id
          url
          thumbnailUrl
        }
        pageName
        defaultTab
        visibleTabs
        needToSetup
      }
      availablePageCount
    }
  }
`;
